import { isWorkshopParentFrontend } from '@/config';
import CustomerCard from './customer/CustomerCard';
import WorkshopCard from './workshop/WorkshopCard';

const EngineOilCard = () => (isWorkshopParentFrontend() ? <WorkshopCard /> : <CustomerCard />);

export default EngineOilCard;
